export default __webpack_public_path__ + "static/media/frontini-logo.725ba57f.svg";